export const S = {
  // 휴대폰은 공통 틀(AdminLayout main)이 좌우 16px 을 준다 — 겹치지 않게 0 (2026-09-28)
  // (페이지 파일이 300줄 초과라 여기서 판정: 페이지와 같은 기준 window.innerWidth <= 768,
  //  getter 라 렌더할 때마다 새 객체를 돌려줘 화면 폭이 바뀌면 React 가 다시 적용한다)
  get page() {
    const isMobile = window.innerWidth <= 768;
    return {
      maxWidth: 1440,
      margin: '0 auto',
      // 상단 여백은 표준 헤더(stdHeaderRow)가 처리 — 2026-08-27 디자인 표준 통일
      padding: isMobile ? '0 0 28px' : '0 12px 28px',
      display: 'flex',
      flexDirection: 'column',
      gap: 14,
    };
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },
  topActions: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' },
  title: { margin: 0, fontSize: 22, fontWeight: 950, color: 'var(--text)', letterSpacing: 0 },
  subTitle: { marginTop: 4, fontSize: 12, color: 'var(--text-muted)' },
  // 회사 탭 — 표준 알약 토글(stdTabGroup/stdTabBtn)과 동일 톤 (2026-08-27 디자인 표준 통일)
  companyTabs: {
    display: 'inline-flex',
    width: 'fit-content',
    maxWidth: '100%',
    padding: 3,
    borderRadius: 999,
    background: 'var(--bg-subtle)',
    overflowX: 'auto',
  },
  companyTab: (active) => (active
    ? {
        background: 'var(--std-pill-on-bg, rgba(59,154,242,0.12))', borderRadius: 999, padding: '5px 14px',
        fontWeight: 700, fontSize: 12, border: 'none', cursor: 'pointer', color: 'var(--std-pill-on-text, #1d7de6)',
        whiteSpace: 'nowrap',
      }
    : {
        background: 'transparent', border: 'none', padding: '5px 14px',
        fontWeight: 600, fontSize: 12, color: 'var(--text-muted)', cursor: 'pointer', borderRadius: 999,
        whiteSpace: 'nowrap',
      }),
  card: {
    border: '1px solid var(--border)',
    borderRadius: 12,
    background: 'var(--bg-card)',
    boxShadow: 'none',
    overflow: 'hidden',
  },
  sectionHead: {
    padding: '13px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
    borderBottom: '1px solid var(--border)',
    background: 'var(--bg-subtle)',
  },
  sectionTitle: { margin: 0, fontSize: 15, fontWeight: 950, color: 'var(--text)' },
  sectionSub: { marginTop: 3, fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.45 },
  // 주요 CTA — 표준 검정 버튼(stdBlackBtn) 톤 (2026-08-27 디자인 표준 통일)
  primaryBtn: {
    border: '1px solid var(--std-btn, #0f172a)',
    borderRadius: 12,
    padding: '8px 14px',
    background: 'var(--std-btn, #0f172a)',
    color: '#fff',
    fontWeight: 700,
    fontSize: 12,
    cursor: 'pointer',
  },
  secondaryBtn: {
    height: 32,
    border: '1px solid var(--border)',
    borderRadius: 8,
    padding: '0 12px',
    background: 'var(--bg-card)',
    color: 'var(--text-sub)',
    fontSize: 12,
    fontWeight: 800,
    cursor: 'pointer',
  },
  // 보조 버튼 — 표준 외곽선 버튼(stdOutlineBtn) 톤 (2026-08-27 디자인 표준 통일)
  histBtn: {
    border: '1px solid var(--border)',
    borderRadius: 12,
    padding: '8px 14px',
    background: 'var(--bg-card)',
    color: 'var(--text-sub)',
    fontWeight: 700,
    fontSize: 12,
    cursor: 'pointer',
  },
  empty: { padding: 24, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 },
  // 옛 변경 기록 창 모양은 2026-10-06 공용 창(MarketerConsultantHistoryModal)으로 바꾸며 지움
};
